<template>
  <div />
</template>

<script>
import { metatagifront } from "./metatagifront.js";
import { metatagizestawienia } from "./metatagizestawienia.js";
import { metatagigeocommon } from "./metatagigeocommon.js";
import { metatagipotwierdzenieOK } from "./metatagipotwierdzenieOK.js";
import { metatagipotwierdzenieError } from "./metatagipotwierdzenieError.js";
import { metatagipogoda } from "./metatagipogoda.js";
import { metatagionas } from "./metatagionas.js";
import { metatagilistaportali } from "./metatagilistaportali.js";
import { metatagilistahoteli } from "./metatagilistahoteli.js";
import { metatagimapaserwisu } from "./metatagimapaserwisu.js";
import { metatagirodzajofert } from "./metatagirodzajofert.js";
import brandLogotype from "@/assets/images/static/travelone-logo.svg";
import * as CONFIG from "./config.js";

export default {
  props: {
    rodzajstrony: String
  },
  data: () => ({
    title: "",
    description: "",
    metasrcfront: metatagifront.Page,
    metasrczest: metatagizestawienia.Page,
    metasrcrezOk: metatagipotwierdzenieOK.Page,
    metasrcrezErr: metatagipotwierdzenieError.Page,
    metasrcpogoda: metatagipogoda.Page,
    metasrconas: metatagionas.Page,
    metasrclistaportali: metatagilistaportali.Page,
    metasrclistahoteli: metatagilistahoteli.Page,
    metasrcmapaserwisu: metatagimapaserwisu.Page,
    metasrcrodzajofert: metatagirodzajofert.Page,
    logotypeSrc: brandLogotype,
    allowedUrls: ["/rodzaj-oferty/lato-2021.xml"]
  }),
  methods: {
    getTitle() {
      if (this.rodzajstrony == "front") {
        return this.metasrcfront["meta-tagi"].Title;
      } else if (this.rodzajstrony == "zestawienia") {
        return this.metasrczest["meta-tagi"].Title;
      } else if (this.rodzajstrony == "rezerwacjaOK") {
        return this.metasrcrezOk["meta-tagi"].Title;
      } else if (this.rodzajstrony == "rezerwacjaError") {
        return this.metasrcrezErr["meta-tagi"].Title;
      } else if (this.rodzajstrony == "pogoda") {
        return this.metasrcpogoda["meta-tagi"].Title;
      } else if (this.rodzajstrony == "onas") {
        return this.metasrconas["meta-tagi"].Title;
      } else if (this.rodzajstrony == "listaportali") {
        return this.metasrclistaportali["meta-tagi"].Title;
      } else if (this.rodzajstrony == "listahoteli") {
        return this.metasrclistahoteli["meta-tagi"].Title;
      } else if (this.rodzajstrony == "mapaserwisu") {
        return this.metasrcmapaserwisu["meta-tagi"].Title;
      } else if (this.rodzajstrony == "rodzajofert") {
        return this.metasrcrodzajofert["meta-tagi"].Title;
      } else {
        return this.title;
      }
    },
    getDescription() {
      if (this.rodzajstrony == "front") {
        return this.metasrcfront["meta-tagi"].Description;
      } else if (this.rodzajstrony == "zestawienia") {
        return this.metasrczest["meta-tagi"].Description;
      } else if (this.rodzajstrony == "rezerwacjaOK") {
        return this.metasrcrezOk["meta-tagi"].Description;
      } else if (this.rodzajstrony == "rezerwacjaError") {
        return this.metasrcrezErr["meta-tagi"].Description;
      } else if (this.rodzajstrony == "pogoda") {
        return this.metasrcpogoda["meta-tagi"].Description;
      } else if (this.rodzajstrony == "onas") {
        return this.metasrconas["meta-tagi"].Description;
      } else if (this.rodzajstrony == "listaportali") {
        return this.metasrclistaportali["meta-tagi"].Description;
      } else if (this.rodzajstrony == "listahoteli") {
        return this.metasrclistahoteli["meta-tagi"].Description;
      } else if (this.rodzajstrony == "mapaserwisu") {
        return this.metasrcmapaserwisu["meta-tagi"].Description;
      } else if (this.rodzajstrony == "rodzajofert") {
        return this.metasrcrodzajofert["meta-tagi"].Description;
      } else {
        return this.description;
      }
    },
    getKeywords() {
      if (this.rodzajstrony == "front") {
        return this.metasrcfront["meta-tagi"].Keywords;
      } else if (this.rodzajstrony == "zestawienia") {
        return this.metasrczest["meta-tagi"].Keywords;
      } else if (this.rodzajstrony == "rezerwacjaOK") {
        return this.metasrcrezOk["meta-tagi"].Keywords;
      } else if (this.rodzajstrony == "rezerwacjaError") {
        return this.metasrcrezErr["meta-tagi"].Keywords;
      } else if (this.rodzajstrony == "pogoda") {
        return this.metasrcpogoda["meta-tagi"].Keywords;
      } else if (this.rodzajstrony == "onas") {
        return this.metasrconas["meta-tagi"].Keywords;
      } else if (this.rodzajstrony == "listaportali") {
        return this.metasrclistaportali["meta-tagi"].Keywords;
      } else if (this.rodzajstrony == "listahoteli") {
        return this.metasrclistahoteli["meta-tagi"].Keywords;
      } else if (this.rodzajstrony == "mapaserwisu") {
        return this.metasrcmapaserwisu["meta-tagi"].Keywords;
      } else if (this.rodzajstrony == "rodzajofert") {
        return this.metasrcrodzajofert["meta-tagi"].Keywords;
      } else {
        return this.title;
      }
    },
    getBaseHref() {
      return "https://www." + CONFIG.serwis;
    },
    getPathnameWithoutDigits(val) {
      if (this.allowedUrls.includes(val)) {
        return val;
      } else {
        let result = val.replace(/[0-9]/g, "");
        return result;
      }
    },
    getCanonical(withBaseDomain, origin) {
      if (withBaseDomain && origin) {
        return this.getBaseHref() + this.$route.path;
      } else if (
        withBaseDomain &&
        window.location.pathname.indexOf("/hotele/hotel.xml") === -1
      ) {
        var addon = this.addPageParameter(true, false);
        return (
          window.location.protocol +
          "//www." +
          CONFIG.serwis +
          this.getPathnameWithoutDigits(window.location.pathname) +
          addon
        );
      } else {
        return (
          window.location.protocol +
          "//" +
          window.location.hostname +
          this.$route.fullPath
        );
      }
    },
    addPageParameter(canonical, desc) {
      let addon = "";
      if (this.rodzajstrony == "zestawienia") {
        let lparams = this.$route.query;
        if (lparams["page"]) {
          var page = lparams["page"];
          if (page !== "1") {
            if (canonical) {
              addon = "?page=" + page;
            } else if (desc) {
              addon = "The Results of Page " + page + ": ";
            } else {
              addon = ", strona " + page;
            }
          }
        }
      }
      return addon;
    },
    getLinks() {
      var p = [];
      var canonical = {
        rel: "canonical",
        href: this.getCanonical(true, false)
      };
      p.push(canonical);
      var appleTouchIcon = {
        rel: "icon",
        sizes: "180x180",
        href: "/img/static/favicon/apple-touch-icon.png"
      };
      p.push(appleTouchIcon);
      var favIconSmall = {
        rel: "icon",
        type: "image/png",
        sizes: "16x16",
        href: "/img/static/favicon/favicon-16x16.png"
      };
      p.push(favIconSmall);
      var favIconMedium = {
        rel: "icon",
        type: "image/png",
        sizes: "32x32",
        href: "/img/static/favicon/favicon-32x32.png"
      };
      p.push(favIconMedium);
      var manifest = {
        rel: "manifest",
        href: "/img/static/favicon/travelone.webmanifest"
      };
      p.push(manifest);
      var maskIcon = {
        rel: "mask-icon",
        href: "/img/static/favicon/safari-pinned-tab.svg",
        color: "#5bbad5"
      };
      p.push(maskIcon);
      var shortcutIcon = {
        rel: "shortcut icon",
        href: "/img/static/favicon/favicon.ico"
      };
      p.push(shortcutIcon);
      return p;
    },
    getMeta() {
      var p = [];
      var desc = {
        name: "description",
        content: this.getDescription(),
        id: "desc"
      };
      p.push(desc);
      var keys = {
        name: "keywords",
        content: this.getKeywords(),
        id: "keywords"
      };
      p.push(keys);
      var msTileColor = {
        name: "msapplication-TileColor",
        content: "#5bbad5"
      };
      p.push(msTileColor);
      var themeColor = {
        name: "theme-color",
        content: "#ffffff"
      };
      p.push(themeColor);
      return p;
    },
    getPanstwoNazwa() {
      return CONFIG.panstwo_nazwa;
    },
    getSerwis() {
      return CONFIG.serwis;
    },
    getScripts() {
      var p = [];
      var jsonp1 = {
        "@context": "http://schema.org",
        "@type": "Organization",
        url: "https://" + this.getSerwis(),
        logo: "https://www." + this.getSerwis() + this.logotypeSrc,
        contactPoint: [
          {
            "@type": "ContactPoint",
            telephone: "+48 71 771 76 21",
            contactType: "Customer service"
          }
        ],
        sameAs: [
          "https://www.facebook.com/TravelOne",
          "https://www.pinterest.com/travelonepl",
          "https://twitter.com/Travelonepl",
          "https://travelonepl-blog.tumblr.com",
          "https://www.youtube.com/user/TRAVELONEpl"
        ]
      };
      var p1 = {
        type: "application/ld+json",
        inner: JSON.stringify(jsonp1),
        body: true
      };
      p.push(p1);
      var jsonp2 = {
        "@context": "http://schema.org",
        "@type": "WebSite",
        url: "/",
        potentialAction: {
          "@type": "SearchAction",
          target: "/oferta/szukaj.xml?q={query}",
          "query-input": "required name=query"
        }
      };
      var p2 = {
        type: "application/ld+json",
        inner: JSON.stringify(jsonp2),
        body: true
      };
      p.push(p2);
      return p;
    }
  },
  mounted() {
    var that = this;
    this.$root.$on("update:ofrObjName", val1 => {
      if (that.title == "") {
        that.title = val1;
        insertTitle(val1);
      }
    });
    this.$root.$on("update:geoname", val1 => {
      that.title = val1 + metatagigeocommon + " - " + CONFIG.panstwo_nazwapl;
      insertTitle(that.title);
    });
    this.$root.$on("update:mtitle", val1 => {
      that.title = val1;
      var addon = this.addPageParameter(false, false);
      insertTitle(that.title + addon);
      var canon = this.getCanonical(true, false);
      insertCanonical(canon);
      var desc = this.addPageParameter(false, true);
      insertDescription(this.getDescription(), desc);
    });
    this.$root.$on("update:mdesc", val1 => {
      that.description = val1;
      var desc = this.addPageParameter(false, true);
      insertDescription(val1, desc);
    });
  },
  // Usage with context the component
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function() {
      return {
        inner: this.getTitle()
      };
    },
    meta: function() {
      return this.getMeta();
    },
    script: function() {
      return this.getScripts();
    },
    link: function() {
      return this.getLinks();
    }
  },
  components: {}
};

function insertTitle(val1) {
  jQuery("head title").html(val1);
}
function insertDescription(val1, prefix) {
  jQuery("meta#desc").attr("content", prefix + val1);
}
function insertCanonical(val1) {
  jQuery("link[rel='canonical']").attr("href", val1);
}
</script>
